'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'boombox';
var width = 640;
var height = 512;
var aliases = [128254];
var unicode = 'f8a5';
var svgPathData = 'M48 0L72 0 568 0l24 0 0 24 0 136 48 0 0 48 0 256 0 48-48 0L48 512 0 512l0-48L0 208l0-48 48 0L48 24 48 0zM544 48L96 48l0 112 96 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 96 0 0-112zm48 160L48 208l0 256 544 0 0-256zM176 240a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm48 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoombox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;